// Import React, styles, SVG icons, and navigation hook
import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Footer component displays contact info, social links, and legal disclaimers.
 */
function Footer() {
  // useNavigate hook for client-side navigation
  const navigate = useNavigate();
  return (
    <footer className="background-container  bg-gray-3" id="contact">
      <div className="background-container  bg-primary-1">
        <div className="content-container">
          <div className=" column align-center gap-s">
         
            <div className="body1">
              TAG Mortgages is a trading style of Christopher Allen Private
              Clients Limited is an Appointed Representative of Rosemount
              Financial Solutions (IFA) Ltd which is authorised and regulated by
              the Financial Conduct Authority. Rosemount Financial Solutions
              (IFA) Ltd is entered on the Financial Services Register under
              reference 535515.
              {/*
            <a
              href="https://register.fca.org.uk/s/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline" }}
            >
              (https://register.fca.org.uk/s/)
            </a>
            under reference 535515. Rosemount Financial Solutions (IFA) Ltd is
            authorised and regulated by the Financial Conduct Authority.
          */}
            </div>

            <div className="body1">
              Christopher Allen Private Clients Limited is registered in England
              and Wales (Company Number: 08820469). Registered Address: 7 Arrow
              Court, Adams Way, Alcester, Warwickshire, England, B49 6PU. The
              information on this website is subject to the UK regulatory regime
              and is intended for consumers in the UK.
            </div>
            <div className="body2-semibold">
              Read the{" "}
              <span
                className="body2-semibold"
                onClick={() => navigate("/privacy-policy")}
                style={{ cursor: "pointer", textDecoration: "underline" }}
              >
                Privacy Policy
              </span>{" "}
              here.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

// Export the Footer component as default
export default Footer;
